/*
 * @Description: 公共 数组相关 js
 * @Author: PF
 * @Date: 2022-11-14 18:22:48
 * @LastEditors: PF
 * @LastEditTime: 2026-09-17 15:35:49
 * @FilePath: \ZHXY_VUE3.0\src\utils\index.js
 */

// 数组统计 BEGIN

// 求和
// let arr = [1, 2, 3, 4, 5];
export function sumBy (arr) {
  let sum = 0
  arr.filter(function (item) {
    sum += item
    return sum
  })
  return sum
}
// 统计数量
export function countBy (arr, fn) {
  return arr.map(typeof fn === 'function' ? fn : val => val[fn])
    .reduce((acc, val) => {
      acc[val] = (acc[val] || 0) + 1
      return acc
    }, {})
}

// 获取平均数
export function averageBy (arr, fn) {
  return arr.map(typeof fn === 'function' ? fn : val => val[fn])
    .reduce((acc, val) => acc + val, 0) / arr.length
}

// 最大值
export function maxVal (arr) { return Math.max(...arr) }

// 最小值
export function minVal (arr) { return Math.min(...arr) }

// 数组统计 END

// 通过value寻找key
export function findKeyByValue (obj, value) {
  for (const key in obj) {
    if (obj[key] === value) {
      return key
    }
  }
  return null // 没有找到匹配的键
}

// 修改数组中key值
export function rename (arr, text, value) {
  for (const i in arr) {
    for (const j in arr[i]) {
      if (j === text) {
        json[i][value] = arr[i][j] // 修改属性名为“value”
        delete arr[i][text] // 删除“text”
      }
    }
  }
  return arr
}

// 递归 根据id查询
export function getObjById (list, id) {
  if (!(list instanceof Array)) return null
  for (const i in list) {
    const item = list[i]
    if (item.id === id) return item
    else {
      if (item.children) {
        const obj = getObjById(item.children, id)
        if (obj) return obj
      }
    }
  }
}
// 数组分组
export function groupBy (arr, key) {
  return arr.reduce((acc, curr) => {
    (acc[curr[key]] = acc[curr[key]] || []).push(curr)
    return acc
  }, {})
}

// 中文拼音排序
export function sortChineseArray (arr) {
  return arr.sort(function (a, b) {
    return a.localeCompare(b, 'zh-CN', { sensitivity: 'base' })
  })
}

// 合并去重 - 新旧两个数组合并时某个值重复保留旧数值
export function mergeArrays (oldArray, newArray, key) {
  const oldMap = new Map(oldArray.map(item => [item[key], item]))
  const merged = oldArray.concat(newArray.filter(item => !oldMap.has(item[key])))
  return merged
}
